export default {
  order_status: {
    created: 'Creato',
    assigned: 'In carico',
    pending: 'Offerta inviata',
    accepted: 'Emissione ordine',
    delivering: 'In consegna',
    delivered: 'Consegnato',
    canceled: 'Annullato',
  },
}
